import { ReactNode } from 'react'
import { DialogContent, Container, Box } from '@mui/material'
import MUIDialog from '@mui/material/Dialog'
import { AlertStyles as styles } from './AlertStyles'
import AlertActionButtons from './components/AlertActionsButtons'
import { AlertTitleDialog } from './components/AlertTitleDialog'
import { AlertType } from './enums'

type Props = {
  show: boolean
  type: AlertType
  message: ReactNode
  close: () => void
  accept: () => void
  cancel: () => void
  title?: string
  primaryButtonText?: string
  secondaryButtonText?: string | null
}

export default function AlertDialog({
  show,
  type,
  message,
  close,
  accept,
  cancel,
  title,
  primaryButtonText,
  secondaryButtonText
}: Props): JSX.Element {
  function cancelResult() {
    close()
    cancel()
  }

  return (
    <MUIDialog
      // onClose={close}
      open={show}
      fullWidth
      maxWidth="sm"
      fullScreen={false}
      sx={styles(type).alert}
    >
      <AlertTitleDialog onClose={cancelResult} type={type} title={title} />
      <DialogContent sx={styles(type).content}>
        <Container>{message}</Container>
      </DialogContent>
      <Box sx={styles(type).buttonsContainer}>
        <AlertActionButtons
          type={type}
          accept={accept}
          close={close}
          cancel={cancel}
          primaryButtonText={primaryButtonText}
          secondaryButtonText={secondaryButtonText}
        />
      </Box>
    </MUIDialog>
  )
}
